import React from 'react';
import useVideoStore from './stores/useVideoStore';

function hasContent(html) {
  if (!html) return false;
  var stripped = html.replace(/<[^>]*>/g, '').trim();
  return stripped.length > 0;
}

function VideoProgressBar() {
  var titleId = useVideoStore(function(s) { return s.title_id; });
  var contentId = useVideoStore(function(s) { return s.content_id; });
  var thumbnail = useVideoStore(function(s) { return s.thumbnail; });
  var thumbnailUrl = useVideoStore(function(s) { return s.thumbnail_url; });
  var hospitalId = useVideoStore(function(s) { return s.hospital_id; });
  var videoUrl = useVideoStore(function(s) { return s.video_url; });
  var doctorIds = useVideoStore(function(s) { return s.doctor_ids; });
  var tagList = useVideoStore(function(s) { return s.tag_list; });
  var categoryList = useVideoStore(function(s) { return s.category_list; });
  var metaDescription = useVideoStore(function(s) { return s.meta_description; });

  var progress = 0;
  if (titleId) progress += 15;
  if (hasContent(contentId)) progress += 10;
  if (thumbnail || thumbnailUrl) progress += 10;
  if (hospitalId) progress += 10;
  if (videoUrl) progress += 20;
  if (doctorIds && doctorIds.length > 0) progress += 10;
  if (tagList && tagList.length > 0) progress += 10;
  if (categoryList && categoryList.length > 0) progress += 5;
  if (metaDescription) progress += 10;

  return (
    <div className="article-form-new__progressbar">
      <div className="article-form-new__progressbar-track">
        <div
          className={'article-form-new__progressbar-fill' + (progress >= 100 ? ' article-form-new__progressbar-fill--complete' : '')}
          style={{ width: progress + '%' }}
        />
      </div>
      <span className="article-form-new__progressbar-label">{progress}%</span>
    </div>
  );
}

export default VideoProgressBar;
